import React from 'react'
import DefaultLayout from './default'
import { TOPID } from '../../utils/runtimeConstants'
import styled from 'styled-components'
import SelectForm from './SelectForms'
import SelectFromGlobal from './SelectForms/selectFromGlobal'
import MutationButton from './SelectForms/mutationButton'
import RefreshButton from './SelectForms/refreshButton'
import BlockRecord from './blockRecord'

const USERDATA = TOPID

/* AppUI is (or should be) a "visual" component, concerned primarily with how to present stuff, while the outer
   AppContainer component is the "container" component that is concerned with the data itself... hopefully this
   distinction should facilitate less confusion about how data gets kepts up to date through the lifecycle of an app. */

const AppScreen = styled.div`
    background-color: ${props => props.theme.colorTable.plain};
    color: ${props => props.theme.colorTable.textLight};
`

const AppNav = styled.div``

export default function AppUI (props) {
  // console.log('props', props)
  const {
    context,
    isNew,
    disableComplete,
    hideNav,
    finish,
    saveAndExit,
    linkedQuery,
    autoLink,
    selectFrom,
    autoSelect,
    selectOnce,
    blockRecord,
    onContinue,
  } = props
  const recordId = context.recordId
  const childState = context.getChildContext(USERDATA)
  const type = childState.typeDef
  if (!type) {
    throw new Error('App cannot launch with undefined type')
  }
  // ? context.refreshUserData() ?

  const handleObjectChange = (key, val) => {
    childState.mutateVarData(key, val)
  }

  let queryStatus, queryDef, queryDefSel
  if (linkedQuery) {
    queryStatus = childState.getQueryStatus(linkedQuery)
    queryDef = queryStatus && queryStatus.queryDef
  }
  if (selectFrom) {
    queryDefSel = childState.getGlobalDef(selectFrom)
  }

  // the following illustrates the beginnings of how we may implement an upcoming feature:
  // to warn, before the user leaves an app, when they have made any changes
  // to linked objects which may be overwritten next time the app is run!
  // let test = Array.from(childState.queryLinks())
  // if (test && test.length > 0) {
  //   console.log(test)
  // }

  // const handleExit = (complete) => {
  //   if (complete)
  // }

  const rendered = (
    <div className={'row mt-n2'}>
      <div className="col-11 mx-auto mt-3">
        <AppScreen className={'p-4 overflow-auto'}
                   style={{
                     maxHeight: hideNav
                       ? 'calc(100vh - 5.5rem)'
                       : 'calc(100vh - 9.0rem)',
                   }}>
          <DefaultLayout context={childState}
                         topRecordId={recordId}
                         inLinkedObj={Boolean(queryDef)}
                         change={handleObjectChange}/>
        </AppScreen>
        <AppNav className={'px-0 pt-3 d-flex flex-row'}>
          {queryDefSel && (
            (queryDefSel.type === 'query' ||
              (queryDefSel.source && queryDefSel.provider))
              ? <SelectForm def={queryDefSel}
                            context={childState}
                            spaceRight={true}
                            autoShow={autoSelect && isNew}
                            hideButton={selectOnce &&
                              !!childState.wasSelectedFrom}/>
              : <SelectFromGlobal def={queryDefSel}
                                  context={childState}
                                  spaceRight={true}
                                  autoShow={autoSelect && isNew}
                                  hideButton={selectOnce &&
                                    !!childState.wasSelectedFrom}/>
          )}
          {queryDef && (
            queryStatus.linkInstanceId
              ? <RefreshButton queryStatus={queryStatus} context={childState}
                               spaceRight={true}/>
              : <SelectForm def={queryDef}
                            queryStatus={queryStatus}
                            context={childState}
                            spaceRight={true}
                            autoShow={autoLink && isNew}/>
          )}
          {queryDef && queryStatus.hasLink && queryStatus.canModify && (
            <MutationButton def={queryDef} queryStatus={queryStatus}
                            spaceRight={true}
                            childContext={childState} context={context}/>
          )}
          <div className={'ml-auto d-flex'}>
            {!context.isGlobalApp && (
              <button
                className="btn btn-outline-secondary dart-btn-outline ml-3" /* disabled={!done} */
                style={{ backgroundColor: '#FFFFFF' }}
                onClick={saveAndExit}>Finish Later
              </button>
            )}
            <button className="btn btn-outline-secondary dart-btn-outline ml-3"
                    disabled={disableComplete}
                    onClick={finish}
                    style={{ backgroundColor: '#FFFFFF' }}
            >
              {disableComplete
                ? 'Loading ...'
                : context.isGlobalApp
                  ? 'Done'
                  : context.hasDocs
                    ? 'Create Docs'
                    : 'Complete'
              }
            </button>
          </div>
        </AppNav>
      </div>
      {blockRecord && (
        <BlockRecord onBlock={saveAndExit} onContinue={onContinue}
                     onFinish={finish}/>)}
    </div>
  )
  return rendered
}
